import style from './tabs-secondary.scss';
import {script as navTabulation} from './../../molecules/nav-tab/nav-tab';
import {script as mediaSlider} from './../../molecules/media-slider/media-slider';
import {script as mediaGallery} from './../../molecules/media-gallery/media-gallery';

const script = () => {
  const cssClass: string = 'TabsSecondary';
  const cssClassItem: string = 'TabSecondary';
  const target: string = `.${cssClass}`;
  const targets: any = document.querySelectorAll(target);

  for (const elt of targets) {

    // test if element is init
    if (elt.dataset[`init${cssClass}`]) {
      return true; // already init go to next iteration
    }
    // init element
    elt.dataset[`init${cssClass}`] = true;

    // Do your stuff here
    const listClass: string = `.${cssClass}-list`;
    const list: any = elt.querySelector(listClass);

    // Create div of tab buttons
    const listTabs: any = document.createElement('div');
    listTabs.classList.add(`${cssClass}-tabs`);
    list.insertAdjacentElement('beforebegin', listTabs);
    const navTab: any = document.createElement('div');
    navTab.classList.add('NavTab');
    listTabs.prepend(navTab);
    navTabulation();

    const itemsClass: string = `.${cssClassItem}-trigger`;
    const items: any = elt.querySelectorAll(itemsClass);
    const classActive = 'isActive';

    const blockClass: string = `.${cssClassItem}`;
    const block: any = elt.querySelector(blockClass);

    block.classList.add(classActive);


    // Accordeon for each item/tab
    for (const item of items) {

      const tabContent = item.textContent;
      const tab: any = document.createElement('button');
      tab.type = 'button';
      tab.classList.add('NavTab-item');
      tab.innerHTML = tabContent;
      navTab.appendChild(tab);
      tab.item = item;

      item.addEventListener('click', () => {
        if (!item.closest(blockClass).classList.contains(classActive)) {
          collapseAllDropdown();
          item.closest(blockClass).classList.toggle(classActive);
        }
        mediaSlider();
        mediaGallery();
      });

      tab.addEventListener('click', () => {
        tab.item.click();
        if (!tab.classList.contains(classActive)) {
          tagButton();
          tab.classList.toggle(classActive);
        }
      });
    }
    const targetsListTabsItem: any = elt.querySelectorAll(`.NavTab-item`);
    targetsListTabsItem[0].classList.add(classActive);

    function tagButton() {
      for (const targetTab of targetsListTabsItem) {
        if (targetTab.classList.contains(classActive)) {
          targetTab.classList.remove(classActive);
        }
      }
    }

    function collapseAllDropdown() {
      for (const item of items) {
        if (item.closest(blockClass).classList.contains(classActive)) {
          item.closest(blockClass).classList.remove(classActive);
        }
      }
    }
  }
};

export {
  style,
  script,
};
